export default "__VITE_ASSET__BBvaLZZ1__"